module.exports = __webpack_public_path__ + "static/media/cover.ed15dac3.png";